module.exports = __webpack_public_path__ + "static/altana-jesien_thumb-c71f059677d9624c55c7c495d63a177a.jpg";